import { render, staticRenderFns } from "./license-notice.vue?vue&type=template&id=98e7179a&"
import script from "./license-notice.vue?vue&type=script&lang=js&"
export * from "./license-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports